import React, { useState, useEffect } from 'react';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v2_categories, v2_channels } from '../../actions/v2/masterData';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import RemarksSelect from '../common/RemarksSelect';

const CreatePlanApprovalForm = ({ onSubmit, shipId, shipName, projectId }) => {
    const [state, setState] = useState({
        subject: { name: 'subject', value: '', isRequired: true, error: '' },
        channel: { name: 'hull', value: '', options: [], isRequired: true, error: '' },
        category: { name: 'hull', value: '', options: [], isRequired: true, error: '' },
        remarks: { name: 'remarks', value: '', isRequired: false, error: '' },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const renderInput = (label, name, placeholder = '') => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <input
                type="text"
                name={name}
                value={state[name].value}
                placeholder={placeholder}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            />
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );

    const renderSelect = (label, name, options = []) => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <select
                name={name}
                value={state[name].value}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            >
                <option value="">Select {label}</option>
                {options.map(opt => (
                    <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
            </select>
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );

    useEffect(() => {

        v2_categories().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['category']: {
                        ...prev['category'],
                        options: res.result.map((item) => {
                            return {
                                ...item,
                                id: item.ID,
                                name: `${item.CATEGORY_NAME}`
                            }
                        })
                    },

                }));
            }
            else {
                toast.error(res.error || res.error.message)
            }
        })

        v2_channels().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['channel']: {
                        ...prev['channel'],
                        options: res.result.map((item) => {
                            return {
                                ...item,
                                id: item.ID,
                                name: `${item.CHANNEL_NAME}`
                            }
                        })
                    },

                }));
            }
            else {
                toast.error(res.error || res.error.message)
            }
        })


    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);

        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        const payload = {
            subject: state.subject.value,
            channelId: state.channel.value,
            categoryId: state.category.value,
            remarks: state.remarks.value,
        };

        onSubmit(payload);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {renderInput('Subject', 'subject', 'Enter Subject')}
                {renderSelect('Category', 'category', state.category.options)}
                {renderSelect('Channel', 'channel', state.channel.options)}

                <RemarksSelect
                    label="Remarks"
                    name="remarks"
                    value={state.remarks.value}
                    onChange={handleChange}
                    error={state.remarks.error}
                    required={state.remarks.isRequired}
                    placeholder="Enter remarks"
                />
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Submit</button>
                <Link
                    className="btn btn-danger text-white"
                    to={{
                        pathname: constant.Authedcomponent.ncrList.url,
                        state: {
                            shipId,
                            shipName,
                            projectId
                        },
                    }}
                >
                    Cancel
                </Link>

            </div>
        </form>
    );
};

export default CreatePlanApprovalForm;
